import { useEffect } from 'react';

interface PageTitleProps {
    title?: string;
}

export const PageTitle = ({ title }: PageTitleProps) => {
    const setPageTitle = () => {
        const h1Element = document.querySelector('h1');
        const pageTitleElement = h1Element?.textContent;
        document.title = pageTitleElement || 'Clinical Skills';
    };

    useEffect(() => {
        if (title) {
            document.title = title;
            return;
        }
        setPageTitle();
    }, [title]);
    return null;
};

PageTitle.defaultProps = {
    title: undefined,
};
